<template>
  <el-card
    v-loading="loading"
    shadow="never"
  >
    <div slot="header">
      <span>Search by:</span>
      <el-button
        type="text"
        @click.native="reset"
      >
        Reset All
      </el-button>
    </div>
    <template v-if="filterables.length">
      <template v-for="(filter, index) in filters">
        <FilterRow
          v-if="!filter.hidden"
          :key="filter.id"
          :resource="resource"
          :filter="filter"
          :filterables="filterables"
          @apply="apply"
          @delete="remove(index)"
        />
      </template>

      <div class="pt-3">
        <el-button
          size="mini"
          @click.native="add"
        >
          Add Filter
        </el-button>

        <div class="float-right">
          <el-button
            size="mini"
            @click.native="clear"
          >
            Clear
          </el-button>
          <el-button
            type="primary"
            size="mini"
            @click.native="apply"
          >
            Apply
          </el-button>
        </div>
      </div>
    </template>

    <p
      v-else
      class="w-100 text-center text-muted p-3"
    >
      No Filters Available
    </p>
  </el-card>
</template>

<script>
import Filter from '@/plugins/sdk/Filter'
import FilterRow from '@/components/Filters/Complex/Filter'
import Resource from '@/plugins/sdk/Resource'
import { mapMutations, mapGetters } from 'vuex'
import { SET_FILTERS } from '@/store/mutation-types'

export default {
  components: {
    FilterRow
  },
  props: {
    resource: {
      type: [ Object, Function ],
      required: true,
      validator: function (value) {
        return value instanceof Resource || value.prototype instanceof Resource
      }
    },
    filters: {
      type: Array,
      required: false,
      default: () => ([])
    },
    context: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      initialFilters: undefined,
      // Filterables are the available filters
      // for the resource.
      filterables: []
    }
  },
  computed: {
    ...mapGetters({
      getFilters: 'filter/filters'
    })
  },
  watch: {
    filters (value) {
      if (value.filter(f => !f.persistent && !f.hidden).length < 1) {
        // Enforce that at least one filter
        // is always present
        this.add()
      }
    }
  },
  created () {
    // When the filters component is created obtain all
    // filters available for the resource
    this
      .$sdk
      .filter
      .list(request => {
        request.filters = { resource: `${this.context ? this.context + '_' : ''}${this.resource}` }
      })
      .then(filters => {
        this.$emit('update:filters', this.$_.filter(this.filters, (filter) => {
          return typeof this.$_.find(filters, ['field', filter.field]) !== 'undefined'
        }))

        this.filterables = filters
      })
      .finally(() => {
        this.$nextTick(() => {
          this.initialFilters = this.$_.cloneDeep(this.filters)

          if (this.getFilters(this.$route.fullPath)) {
            this.$emit('update:filters', this.getFilters(this.$route.fullPath))
          }

          this.loading = false
          this.$emit('ready')
        })
      })
  },
  methods: {
    ...mapMutations({
      setFilters: `filter/${SET_FILTERS}`
    }),
    /**
     * Adds a new filter.
     */
    add () {
      this.$emit('update:filters', [ ...this.filters, new Filter() ])
    },
    /**
     * Removes a filter by its position in the filters array.
     *
     * @param      {Number}  index   The filter index
     */
    remove (index) {
      this.$emit('update:filters', this.$_.filter(this.filters, (f, i) => {
        return i !== index
      }))
    },
    /**
     * Resets filters to their initial state
     */
    reset () {
      this.$emit('update:filters', this.$_.cloneDeep(this.initialFilters))

      this.$nextTick(() => {
        this.apply()
      })
    },
    /**
     * Clears non-persistent filters.
     */
    clear () {
      this.$emit('update:filters', this.$_.filter(this.filters, (f) => {
        return f.persistent
      }))

      this.$nextTick(() => {
        this.apply()
      })
    },
    /**
     * Applies the filters.
     */
    apply () {
      this.setFilters({ routePath: this.$route.fullPath, filters: this.filters })
      this.$emit('apply')
    }
  }
}
</script>
